/**
 * Hjälpare för påminnelsenotiser om förväntad födsel.
 * Notistexten från cron-jobbet innehåller taggen [breeding:<record_id>:<dagar>].
 */

const TAG_RE = /\[breeding:([0-9a-fA-F-]{36}):(\d+)\]/;

export interface BreedingNotificationRef {
  recordId: string;
  daysBefore: number;
}

export function parseBreedingTag(body: string | null | undefined): BreedingNotificationRef | null {
  if (!body) return null;
  const m = body.match(TAG_RE);
  if (!m) return null;
  return { recordId: m[1], daysBefore: Number(m[2]) };
}

/** Tar bort den tekniska taggen ur texten som visas för användaren. */
export function cleanNotificationBody(body: string | null | undefined): string {
  if (!body) return "";
  return body.replace(TAG_RE, "").replace(/\s{2,}/g, " ").trim();
}
